// extracted by mini-css-extract-plugin
export default {"endedRow":"endedRow---G21Zr","emptyState":"emptyState---WJfdJ"};